<!-- eslint-disable vue/valid-v-for -->
<template>
  <v-sheet flat border class="pa-4 col-sm-12">
    <p class="text-subtitle-1 pt-3 text-primary">
      <span class="font-weight-bold">Solar Prediction</span>
      - Input values at execution time
    </p>
    <v-row>
      <v-col sm="4">
        <v-text-field
          v-model="localInputData.CurrentDateTime"
          :rules="[isDate]"
          variant="outlined"
          label="Current Date/Time"
          type="datetime-local"
        />
      </v-col>
      <v-col sm="4">
        <v-text-field
          v-model="localInputData.ReadingDateTime"
          :rules="[isDate]"
          variant="outlined"
          label="Reading Date/Time"
          type="datetime-local"
        />
      </v-col>
      <v-col sm="4">
        <v-text-field
          v-model="localInputData.DelayInMinutes"
          :rules="[isNumberGreaterThanZero]"
          variant="outlined"
          label="Delay in Minutes"
        />
      </v-col>
    </v-row>
    <BusinessHoursInput
      v-model:start-time="localInputData.SiteStartTime"
      v-model:end-time="localInputData.SiteEndTime"
    />
    <v-row>
      <v-col sm="3">
        <v-text-field
          v-model="localInputData.MonthNumber"
          :rules="[(val) => val >= 1 && val <= 12]"
          variant="outlined"
          label="Month Number (1-12)"
        />
      </v-col>
      <v-col sm="3">
        <v-text-field
          v-model="localInputData.ReadingHour"
          :rules="[(val) => val >= 1 && val <= 24]"
          variant="outlined"
          label="Reading Hour (1-24)"
        />
      </v-col>
      <v-col sm="3">
        <v-text-field
          v-model="localInputData.SolarOutput"
          :rules="[isNumber]"
          variant="outlined"
          label="Solar Output (kWh)"
        />
      </v-col>
      <v-col sm="3">
        <v-text-field
          v-model="localInputData.Temperature"
          :rules="[isNumber]"
          variant="outlined"
          label="Temperature"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col sm="3">
        <v-text-field
          v-model="localInputData.CloudCover"
          :rules="[isNumber]"
          variant="outlined"
          label="Cloudiness Factor (%)"
        />
      </v-col>
      <v-col sm="3">
        <v-text-field
          v-model="localInputData.Humidity"
          :rules="[isNumber]"
          variant="outlined"
          label="Humidity (%)"
        />
      </v-col>
      <v-col sm="3">
        <v-text-field
          v-model="localInputData.Precipitation"
          :rules="[isNumber]"
          variant="outlined"
          label="Precipitation Intensity (%)"
        />
      </v-col>
      <v-col sm="3">
        <v-text-field
          v-model="localInputData.SolarRadiation"
          :rules="[isNumber]"
          variant="outlined"
          label="Solar Radiation"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col sm="3">
        <v-text-field
          v-model="localInputData.SolarEnergy"
          :rules="[isNumber]"
          variant="outlined"
          label="Solar Energy"
        />
      </v-col>
    </v-row>
  </v-sheet>
</template>
<script>
import {
  isNumber,
  isNumberGreaterThanZero,
  hasValue,
  isDate,
} from '@/Core.Patterns/Factory/validationFactory.ts';
import BusinessHoursInput from '@/Core.Service.Domain/Strategies/Strategies/Components/BusinessHoursInput.vue';
import { withBaseInputDefaults } from '@/Core.Service.Domain/Strategies/Strategies/Utils/baseInputDefaults.ts';

export default {
  name: 'SolarPredictionInput',

  components: { BusinessHoursInput },
  data() {
    return {
      localInputData: withBaseInputDefaults(this.InputData),
    };
  },

  props: {
    InputData: {
      type: Object,
      required: true,
    },
  },

  watch: {
    localInputData: {
      handler(newVal) {
        this.$emit('update:model', newVal);
      },
      deep: true,
    },
  },

  methods: {
    isNumber,
    isNumberGreaterThanZero,
    hasValue,
    isDate,
  },
};
</script>
